import React, { useState } from 'react';
import './topheader.css';
import { FaFacebook, FaYoutube, FaInstagram, FaLinkedin, FaEnvelope, FaWhatsapp, FaPhone, FaVoicemail, FaTelegramPlane, FaHome } from 'react-icons/fa';
import { BiPhone } from 'react-icons/bi';
import { FiMapPin } from 'react-icons/fi';
// import logo from "../../assets/logo.png";
import Popup from '../popup/Popup';
import logonew from "../../assets/logo_fsky.png"
import call from "../../assets/icons/call-answer-01.png";
import whatsapp from "../../assets/icons/WhatsApp.svg.png";
import map from "../../assets/icons/map.png";
import ReCAPTCHA from "react-google-recaptcha";
import { Link, useNavigate } from 'react-router-dom';
import { Phone, Telegram } from '@mui/icons-material';

function Topheader() {
  const navigate = useNavigate();

  const [isPopupVisible, setPopupVisible] = useState(false);
  const [isQuickPopupVisible, setQuickPopupVisible] = useState(false);

  const showPopup = () => setPopupVisible(true);
  const hidePopup = () => setPopupVisible(false);

  const [formStatus, setFormStatus] = useState("");
  const [error, setError] = useState("");
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
  });


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const toggleQuickPopup = () => {
    setQuickPopupVisible(!isQuickPopupVisible);
  };

  const handleCaptchaChange = (value) => {
    if (value) {
      setCaptchaVerified(true); // Set to true when CAPTCHA is verified
    } else {
      setCaptchaVerified(false); // Set to false if not verified
    }
  };
  const validateForm = () => {
    if (!formData.fullName || !formData.email || !formData.phone || !formData.subject || !formData.message) {
      setError("All fields are required.");
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setError("Invalid email format.");
      return false;
    }
    setError("");
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    if (!captchaVerified) {
      setError("Please verify that you are not a robot.");
      return;
    }
    setLoading(true); // Start loading

    try {
      const response = await fetch("https://demo.firstskyinfra.in/php/contact.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.status === "success") {
        // setFormStatus("Message sent successfully!");
        navigate('/thankyou')
        setFormData({ fullName: "", email: "", phone: "", subject: "", message: "" });
      } else {
        setError(result.message);
      }
    } catch (error) {
      setError("Failed to send message.");

    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <>
      <div className='top-main'>
        <div className='py-1 top' style={{ background: "rgb(53 65 105)", color: "#FDC30B" }}>
          <div className='container top-conatiner' style={{ display: "flex", justifyContent: "center" }}>
            <div className='row top-row'>
              <div class="col-sm text-center text-md-left mb-md-0 mb-2 pr-md-4 d-flex topper align-items-center">
                <p class="mb-0 w-100">
                  {/* <FaEnvelope className="mr-1" /> */}
                  <span class="text">info@firstskyinfra.in</span>
                </p>
              </div>
              <div className='col-sm justify-content-between d-flex mb-md-0 mb-2 '>
                <div className='socialmedia'>
                  <p className="mb-0 d-flex">
                    <a href="https://api.whatsapp.com/send?phone=919500167678" className='d-flex align-items-center justify-content-center' target="_blank" rel="noopener noreferrer" style={{ color: "#FDC30B" }}>
                      <FaWhatsapp />
                    </a>
                    <a href="mailto:info@firstskyinfra.in" className='d-flex align-items-center justify-content-center' target="_blank" rel="noopener noreferrer" style={{ color: "#FDC30B" }}>
                      <FaEnvelope />
                    </a>
                    <a href="https://www.instagram.com/firstskyinfra?igsh=MWRpa3EyOWM3bjZ1cw==" className='d-flex align-items-center justify-content-center' target="_blank" rel="noopener noreferrer" style={{ color: "#FDC30B" }}>
                      <FaInstagram />
                    </a>
                    <a href="https://www.linkedin.com/company/105013075/admin/dashboard/" className='d-flex align-items-center justify-content-center' target="_blank" rel="noopener noreferrer" style={{ color: "#FDC30B" }}>
                      <FaLinkedin />
                    </a>
                  </p>
                </div>

                <div className='top-but-top'>
                  <Link to="/" className="get-button-home1" style={{ color: "#FDC30B", fontSize: "larger" }}>
                    <FaHome size={20} />
                  </Link>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-7 d-flex topper align-items-center text-lg-right justify-content-end" >
                <p class="mb-0 register-link"><a href="#" class="enquiry-button" onClick={toggleQuickPopup}  >Inquire Now</a></p>
              </div>
              <div>


              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="pt-0 pb-0">
        <div className="container topnext-container">
          <div className="row d-flex align-items-start align-items-center px-3 px-md-0">

            {/* Logo and Branding (Visible on all screens) */}
            <div className="col-12 col-md-4 d-flex mb-2 mb-md-0 justify-content-center justify-content-md-start">
              <a
                className="navbar-brand d-flex align-items-center"
                style={{
                  fontSize: "12px",
                  textTransform: "uppercase",
                  color: "#161615",
                  fontWeight: "700",
                }}
                href=""
              >
                <div
                  className="flaticon flaticon-crane"
                  style={{
                    width: "70px",
                    height: "70px",
                    background: "white",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "10%",
                  }}
                >
                  <img src={logonew} width={90} height={90} alt="Logo" />
                </div>
                <span className="ml-2 d-flex align-items-center">
                  First Sky Infrastructure
                </span>
              </a>
            </div>


            {/* Other Details (Hidden on Mobile) */}
            <div className="col-md-8  d-none d-md-flex">
              {/* Contact Details */}
              <div className="col-md-6 d-flex topper mb-md-0 mb-2 align-items-center">
                <div
                  className="icon d-flex justify-content-center align-items-center"
                  style={{
                    width: "40px",
                    height: "40px",
                    // backgroundColor: "#002D62",
                    color: "#FDC30B",
                    // borderRadius: "50%",
                    marginRight: "5px",
                  }}
                >
                  <BiPhone size={30} />
                </div>
                <div
                  className="pr-md-4 pl-md-3 pl-3 text"
                  style={{
                    fontSize: "12px",
                    color: "#161615",
                    fontWeight: "700",
                  }}
                >
                  <p className="con ">
                    <a
                      href="tel:+919500167678"
                      style={{
                        color: "#161615",
                        textDecoration: "none",
                        display: "flex",
                        alignItems: "center",
                        textAlign: "center",
                        marginTop: "19px"
                      }}
                    >
                      +91 9500167678<br></br>

                      Tel-044-48570414
                    </a>
                    {/* <p className="con">Call Us Now 24/7 Customer Support</p> */}
                  </p>

                </div>
              </div>

              {/* Address Details */}
              <div className="col-md-6 d-flex topper mb-md-0 align-items-center">
                <div
                  className="icon d-flex justify-content-center align-items-center"
                  style={{
                    width: "40px",
                    height: "40px",
                    // backgroundColor: "#002D62",
                    color: "#FDC30B",
                    borderRadius: "50%",
                    // marginRight: "5px",
                  }}
                >
                  <FiMapPin size={30} />
                </div>
                <div
                  className="text pl-3 pl-md-3"
                  style={{
                    fontSize: "12px",
                    color: "#161615",
                    fontWeight: "700",
                  }}
                >
                  <p className="hr" style={{
                    color: "#161615",
                    textDecoration: "none",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    marginTop: "19px"
                  }}>No:21, Vinayaga Nagar, Okkiyam <br></br> Thoraipakkam, Chennai-97<br></br></p>
                  {/* <p className="con"></p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section>
        <div className="popup-div">
          <button type="button" className="popup-btn" onClick={toggleQuickPopup}>
            Contact us
          </button>

          {isQuickPopupVisible && (
            <div className="popup active">
              <div className="popup-content">
                <div className="event-header">
                  <h6>Contact us</h6>
                </div>
                <form id="send" className="send-form" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="Enter name..."
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="tel"
                      placeholder="Enter phone..."
                      name="phone"
                      value={formData.phone}
                      onChange={(e) => {
                        const phoneRegex = /^\d{0,10}$/; // Allows only up to 10 digits
                        if (phoneRegex.test(e.target.value)) {
                          setFormData({ ...formData, phone: e.target.value });
                        }
                      }}
                      required
                      pattern="^\d{10}$"
                      title="Phone number must be exactly 10 digits"
                    />
                  </div>


                  <div className="form-group">
                    <input
                      type="email"
                      placeholder="Enter mail..."
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="Enter subject..."
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <textarea
                      placeholder="Enter message..."
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                  <div className="form-group mb-3">
                    <ReCAPTCHA
                      sitekey='6LeiptIqAAAAAKT6diIfDS8Wu3vU-4SEIYxA0yB3'
                      // sitekey="6LcwRb4qAAAAAMq-olseDFdPgiJ4s48v3oLdfMIW"
                      // sitekey="6LdyK74qAAAAAHior1ETtBZRJf6-78AZFgkPYKf3"
                      //  // Replace with your reCAPTCHA site key
                      onChange={handleCaptchaChange}
                    />
                  </div>
                  <p className="form-message">
                    {error && <span className="error-message">{error}</span>}
                    {formStatus && <span className="success-message">{formStatus}</span>}
                  </p>
                  <input
                    type="submit"
                    className="main-btn-rect"
                    value={loading ? "Sending..." : "Submit"}
                    disabled={loading}
                  />

                </form>
                <span className="fade-out" onClick={toggleQuickPopup}>
                  ╳
                </span>
              </div>
            </div>
          )}
        </div>
      </section>

      <section>

        <div className="main-icons">
          <ul className="first">
            <li className="color1">
              <a href="tel:+919500167678">
                <p>Call <br />+91 9500167678</p>
                <img src={call} width="20px" height="20px" className="img-fluid" />
              </a>
            </li>
            <li className="color2">
              <a href="https://api.whatsapp.com/send?phone=919500167678" target="_blank">
                <p>Whatsapp <br />+91 9500167678</p>
                <img src={whatsapp} width="24" height="24" className="img-fluid" />
              </a>
            </li>
            {/* <li className="color3">
              <a
                href="https://maps.app.goo.gl/W9jNi6VWGbfWmbB57"
                target="_blank"
                rel="noopener noreferrer" // Best practice for opening new tabs
              >
                <p style={{ color: "black" }}>Location <br />First Sky Infra</p>
                <img src={map} width="30" height="30" className="img-fluid1" alt="Map Icon" />
              </a>
            </li> */}

          </ul>
        </div>
      </section>
      {/* <Popup isVisible={isPopupVisible} closePopup={hidePopup} /> */}
    </>
  );
}

export default Topheader;
